import script from "./BaseToast.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseToast.vue?vue&type=script&setup=true&lang=js"

import "./BaseToast.vue?vue&type=style&index=0&id=606b0e7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-606b0e7c"]])

export default __exports__